<h1>{{card?.title | translate}}</h1>
<!-- table 1 -->
<app-chart-download-button (buttonClick)="downloadTable()">
  <h2 translate>m2.sprint7.cockpit-kontrolle.einfluss-extremwerte.subtitle</h2>
</app-chart-download-button>

<div class="table-wrapper">
  @if (einflussVonExtremwerten && mitarbeiters) {
    <table>
      <thead>
        <tr>
          <th rowspan="1" class="no-border" scope="col"><br/></th>
          <th class="header centered bold border-bold-left" scope="colgroup">
            {{ 'm2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.laufnummer-ausgeschlossene-personen' |
          translate }}</th>
          <th colspan="2" class="header centered bold border-bold-left" scope="colgroup">
            {{ 'm2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.zu-ungunsten-maenner' | translate }}
          </th>
          <th colspan="2" class="header centered bold border-bold-left" scope="colgroup">
          {{ 'm2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.zu-ungunsten-frauen' | translate }} </th>
          <th class="header centered bold border-bold-left" scope="col">
            {{ 'm2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.gesamtscore-ohne-diese-person' |
            translate
          }} </th>
          <th class="header centered bold border-bold-right" scope="col">
          {{ 'm2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.zu-ungunsten-der' | translate }} </th>
        </tr>
        <tr>
          <td class="header centered border-bold-left"></td>
          <td class="centered border-bold-left border-bold-right"></td>
          <th scope="col" class="centered">
          {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.anzahl-risikopaare' | translate }}</th>
          <th scope="col" class="centered border-bold-right">
            {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.durchschnittliche-lohnunterschiede' |
          translate }}</th>
          <th scope="col" class="centered">
          {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.anzahl-risikopaare' | translate }}</th>
          <th scope="col" class="centered border-bold-right">
            {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.durchschnittliche-lohnunterschiede' |
          translate }}</th>
          <th scope="col" class="centered"></th>
          <th scope="col" class="centered border-bold-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['gesamtesUnternehmen']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.gesamtes_unternehmen'"
        [laufNrAusgechlossenenPers]="'None'"></tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['gesamtesUnternehmenNurGrundlohn']"
          [rowHeaderKey]="'m2.sprint10.cockpit.card.chart.einfluss-extremwerten-ergebnisse.gesamtes_unternehmen_mit_grundlohn'"
          [laufNrAusgechlossenenPers]="'None'">
        </tr>
        <!-- Analyse mit Gesamtlohn -->
        <tr>
          <th scope="colgroup" class="header centered bold border-bold-left border-bold-right">
          {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.analyse-gesamtlohn' | translate}}</th>
          <td class="header border-bold-right"></td>
          <td class="header border-bold-right" colspan="2"></td>
          <td class="header border-bold-right" colspan="2"></td>
          <td class="header border-bold-right" colspan="2"></td>
        </tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['gesamtLohnOhneTiefeLoehne']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.person-tieferem-lohn-erwartet'"
          [mitarbeiters]="mitarbeiters"
          [laufNrAusgechlossenenPers]="'Allowed'">
        </tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['gesamtLohnOhneHoheLoehne']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.vergleichsperson-grossem-einfluss'"
          [mitarbeiters]="mitarbeiters"
          [laufNrAusgechlossenenPers]="'Allowed'">
        </tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['gesamtLohnOhneBeide']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.personen-konstellationen'"
          [mitarbeiters]="mitarbeiters"
          [laufNrAusgechlossenenPers]="'See-Above'">
        </tr>
        <!-- Analyse nur mit Grundlohn -->
        <tr>
          <th scope="colgroup" class="header centered bold border-bold-left border-bold-right">
          {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.analyse-grundlohn' | translate}}</th>
          <td class="header border-bold-right"></td>
          <td class="header border-bold-right" colspan="2"></td>
          <td class="header border-bold-right" colspan="2"></td>
          <td class="header border-bold-right" colspan="2"></td>
        </tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['grundLohnOhneTiefeLoehne']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.person-tieferem-lohn-erwartet'"
          [mitarbeiters]="mitarbeiters"
          [laufNrAusgechlossenenPers]="'Allowed'">
        </tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['grundLohnOhneHoheLoehne']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.vergleichsperson-grossem-einfluss'"
          [mitarbeiters]="mitarbeiters"
          [laufNrAusgechlossenenPers]="'Allowed'">
        </tr>
        <tr app-table-einflussextremwerten-data-row
          [rowdata]="einflussVonExtremwerten['grundLohnOhneBeide']"
          [rowHeaderKey]="'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.personen-konstellationen'"
          [mitarbeiters]="mitarbeiters"
          [laufNrAusgechlossenenPers]="'See-Above'">
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="hint" colspan="8">
            {{'m2.sprint7.cockpit.card.chart.einfluss-extremwerten-ergebnisse.basis-grundgesamtheit-gueltig' |
            translate}}
          </td>
        </tr>
      </tfoot>
    </table>
  }
</div>

